import React from 'react';
import { SdfProgressBar } from '@waypoint/react-components';
export type ProgressStatus = 'complete' | 'in-progress' | 'failed' | 'default' | 'changed' | 'new';

export interface IProgressBar2Props {
  className?: string;
  id?: string;
  label?: string;
  labelAria?: string;
  labelType?: 'none' | 'percentage' | 'custom';
  percentage?: number;
  status?: ProgressStatus;
  title?: React.ReactNode;
  value?: number;
}

export const ProgressBar2 = (props: IProgressBar2Props) => {
  const {
    className,
    id,
    label,
    labelAria,
    labelType,
    percentage,
    status,
    title,
    value
  } = props;

  // Support both 'percentage' (old ProgressBar API) and 'value' (Waypoint API).
  // 'value' takes precedence if both are provided.
  const effectiveValue = value ?? percentage ?? 0;

  // If label is provided but labelType is not, default to 'custom' so the label is visible.
  const effectiveLabelType = labelType ?? (label ? 'custom' : 'none');

  const sdfProps: any = {
    id,
    label,
    labelAria,
    labelType: effectiveLabelType,
    status,
    value: effectiveValue
  };

  Object.keys(sdfProps).forEach((key) => {
    if (sdfProps[key] === undefined) {
      delete sdfProps[key];
    }
  });

  return (
    <div className={className}>
      {title && <div className="font-semibold">{title}</div>}
      <SdfProgressBar {...sdfProps} />
    </div>
  );
};

ProgressBar2.displayName = 'ProgressBar2';
